import { render, staticRenderFns } from "./software-license-view.html?vue&type=template&id=941db9c6&"
import script from "./software-license-view.js?vue&type=script&lang=js&"
export * from "./software-license-view.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports